import { IMedsusDiretriz } from '../../modules/types/Medsus';
import httpClient from '../httpClient';

export const getAllMedsusDiretriz = async () => {
  try {
    const response = await httpClient.get(`/api/medsusdiretriz`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

export const getAllMedsusDiretrizByItem = async (itemId: string) => {
  try {
    const response = await httpClient.get(`/api/medsusdiretriz/vmp/${itemId}`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

export async function getMedsusDiretriz(id: string) {
  try {
    const response = await httpClient.get(`/api/medsusdiretriz/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function handleCreateMedsusDiretriz(form: IMedsusDiretriz) {
  try {
    const response = await httpClient.post(`/api/medsusdiretriz`, form);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function handleUpdateMedsusDiretriz(form: IMedsusDiretriz) {
  try {
    const response = await httpClient.patch(
      `/api/medsusdiretriz/${form.id}`,
      form,
    );

    return response;
  } catch (error) {
    throw error;
  }
}

export async function handleDeleteMedsusDiretriz(id: string | number) {
  try {
    return await httpClient.delete(`/api/medsusdiretriz/${id}`);
  } catch (error) {
    throw error;
  }
}
